// slider
document.addEventListener('DOMContentLoaded', function () {

  // --- Constant Slider -----
  if (document.querySelector('.js-constant-slider')) {
    document.querySelectorAll('.js-constant-slider').forEach(slider => {
      new Swiper(slider, {
        speed: 10000, // スライド変化時間
        loop: true,
        loopAdditionalSlides: 2,
        slidesPerView: 1.5,
        spaceBetween: '5%',
        // centeredSlides: true,
        allowTouchMove: false, // スワイプ無効
        autoplay: {
          delay: 0, //　スライダー表示時間
          disableOnInteraction: false,
        },
        breakpoints: {
          // スライドの表示枚数：500px以上の場合
          561: {
            slidesPerView: 2,
            spaceBetween: '3%',
            loopAdditionalSlides: 2,
          },
          769: {
            slidesPerView: 3,
            spaceBetween: '2%',
            loopAdditionalSlides: 3,
          },
        }
      });
    })
  }

  // --- CASE-STUDY Slider -----
  if (document.querySelector('.js-caseStudy-slider')) {
    const grid = new Swiper('.js-caseStudy-slider', {
      loop: true,	// ループ表示
      speed: 1000,    // スライド変化時間
      slidesPerView: 'auto', // 表示スライド数
      spaceBetween: '8%',   // スライド間の余白
      centeredSlides: true,    // 現在スライドを中央に配置する（初期値: false）
      loopAdditionalSlides: 1,
      breakpoints: {
        // when window width is >= 320px
        // 415: {
        //   slidesPerView: 2.5,
        //   spaceBetween: 20
        // },
        // when window width is >= 568px
        569: {
          slidesPerView: 1.6,
          spaceBetween: '5%',
          centeredSlides: true,
          loopAdditionalSlides: 2,
        },
        // when window width is >= 769px
        769: {
          slidesPerView: 2,
          spaceBetween: '3.7%',
          centeredSlides: true,
          loopAdditionalSlides: 2,
        }
      },
      navigation: {	// 前後ナビゲーション
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {   // ページネーションの設定
        el: '.swiper-pagination',   // ページネーションラッパーのクラス
        type: 'bullets',   // ドットナビゲーション
        clickable: true,   // クリックしてスライド変更（初期値：false）
      },
    });
  }


  // --- COLUMN Slider -----
  if (document.querySelector('.js-column-slider')) {
    const column = new Swiper('.js-column-slider', {
      loop: true,	// ループ表示
      loopAdditionalSlides: 1,
      speed: 1000,    // スライド変化時間
      autoplay: {
        delay: 5000, // スライダー表示時間
        disableOnInteraction: false,
      },
      slidesPerView: 1.2, // 表示スライド数
      spaceBetween: '3.6%',   // スライド間の余白
      centeredSlides: true,    // 現在スライドを中央に配置する（初期値: false）

      breakpoints: {
        569: {
          slidesPerView: 1.5,
        },
        769: {
          slidesPerView: 2,
        }
      },
    });
  }

})